import React, { useContext } from 'react';
import styled from 'styled-components';
import { BlanketStyle } from './Modal.styles.js';
import { ModalContext } from './ModalContext.js';
import { MODAL_ACTION_CLOSE } from './constants.js';
import { useInert } from './hooks.js';

const _ModalBlanket = ({ blanket, // Used only in styling, prevent passing it to DOM
children, className, closeButton, closeOnOutsideClick, cover, // Used only in styling, prevent passing it to DOM
onClick: customBlanketOnClickHandler, onKeyUp: customBlanketOnKeyUpHandler, ...rest }) => {
    var _a;
    const { dispatch } = (_a = useContext(ModalContext)) !== null && _a !== void 0 ? _a : {};
    const dismissable = closeOnOutsideClick || closeButton;
    const ref = useInert();
    const handleBlanketClick = (event) => {
        if (customBlanketOnClickHandler) {
            customBlanketOnClickHandler(event);
        }
        if (closeOnOutsideClick && dispatch) {
            dispatch(MODAL_ACTION_CLOSE);
        }
    };
    const handleBlanketKeyUp = (event) => {
        if (customBlanketOnKeyUpHandler) {
            customBlanketOnKeyUpHandler(event);
        }
        if (dismissable && dispatch && event.key === 'Escape') {
            dispatch(MODAL_ACTION_CLOSE);
        }
    };
    return (React.createElement("div", { ...rest, className: className, onClick: handleBlanketClick, onKeyUp: handleBlanketKeyUp, ref: ref }, children));
};
_ModalBlanket.displayName = '_ModalBlanket';
const ModalBlanket = styled(_ModalBlanket) `
    ${BlanketStyle}
`;

export { ModalBlanket };
//# sourceMappingURL=ModalBlanket.js.map
